import axios from 'axios';
import { useState, useEffect } from 'react';
import { TextField, Autocomplete } from '@mui/material';
import { TFormValues } from '../../types';

interface IProps {
    required?: boolean;
    storeField: string;
    storeEmailField?: string;
    setFieldValue(field: keyof TFormValues, value: string): void;
}

interface IStoreOption {
    email: string;
    name: string;
    storenumber: string;
}

interface IJsonStore {
    u_smd_address: string;
    u_smd_city: string;
    u_smd_addressnumber: string;
    u_smd_storenumber: string;
    u_smd_emailstore: string;
}

export const StoreSection = ({
    required,
    storeField,
    storeEmailField,
    setFieldValue,
}: IProps) => {
    const [stores, setStores] = useState<IStoreOption[] | undefined>();

    useEffect(() => {
        if (!process.env.REACT_APP_STORES_URL_GON) return;

        axios
            .get<IJsonStore[]>(process.env.REACT_APP_STORES_URL_GON)
            .then(({ data }) => {
                const allStores: IStoreOption[] = data.map((store) => ({
                    name: `${store.u_smd_city} - ${store.u_smd_address} ${store.u_smd_addressnumber}`,
                    storenumber: store.u_smd_storenumber,
                    email: store.u_smd_emailstore,
                }));

                setStores(allStores);
            })
            .catch(() => console.error('Error fetching store list'));
    }, []);

    const handleStoreChange = (
        _e: React.SyntheticEvent<Element, Event>,
        value: IStoreOption | null
    ) => {
        if (!value) return;

        if (storeEmailField) {
            setFieldValue(storeEmailField as keyof TFormValues, value.email);
        }

        setFieldValue(storeField as keyof TFormValues, value.name);
    };

    return (
        <>
            {stores && (
                <Autocomplete
                    getOptionLabel={(option: IStoreOption) => option.name}
                    id="store-select"
                    options={stores}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Kies je winkel"
                            required={required}
                        />
                    )}
                    onChange={handleStoreChange}
                />
            )}
        </>
    );
};
